import { FC, useMemo } from 'react'

import {
  Text,
  BorderRadius4,
  CustomerLogo,
  GreyGrey10,
  GreyGrey90,
  Primary14SemiBold,
  Center,
  Flex
} from '@sequencehq/core-components'
import { getLogoSrc } from 'Customer/index'
import { Customer } from '../types'

export const ContractReviewHeader: FC<{
  customer?: Customer
  contractName?: string
}> = ({ customer, contractName }) => {
  const title = useMemo(
    () => contractName ?? 'Untitled contract',
    [contractName]
  )

  return (
    <Flex alignItems="center" gap="8px">
      <Center
        borderRadius={BorderRadius4}
        overflow="hidden"
        boxSize="24px"
        background={GreyGrey10}
      >
        {customer && (
          <CustomerLogo
            src={getLogoSrc(customer)}
            size={24}
            fallbackSize={16}
          />
        )}
      </Center>
      <Text {...Primary14SemiBold} color={GreyGrey90}>
        {title}
      </Text>
    </Flex>
  )
}
